type Features = {
    rudderstackUrl: string;
    rudderstackWriteKey: string;
};

const config = {
    RUDDERSTACK_URL: 'https://bettercollkagp.dataplane.rudderstack.com/v1',
    RUDDERSTACK_WRITE_KEY: '2OZL7Fm7xx7FTSjPAIP7FHMZi8h',
};

export function getFeature<T extends keyof Features>(feature: T): Features[T] | null {
    const features = {
        rudderstackUrl: config.RUDDERSTACK_URL,
        rudderstackWriteKey: btoa(`${config.RUDDERSTACK_WRITE_KEY}:`),
    };

    return features[feature] || null;
}
